import Model from '@/models/Model'

export default class GBank extends Model {
    resource() {
        return 'g_bank'
    }
}